const SectionHeading = ({ secTitle, secIndex }) => {
  return (
    <section className="sec-heading bg-white">
      <div className="container-fluid">
        <div className="row justify-content-between align-items-center">
          <div className="col-12 col-lg-6 text-start">
            <h1>{secTitle}</h1>
          </div>
          <div className="col-12 col-lg-4 float-end">
            <p className="fw-normal">{secIndex}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionHeading;
